module.exports = __webpack_public_path__ + "673a326ea5e77f2c67739bc78c90d886.svg";